import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './styles/reset.css';
import './styles/tokens.css';
import './styles/tw.css';
// 영역별 테마 색(2026-08-20) — 값이 없으면 지금까지의 색을 그대로 쓴다(theme-surfaces.css 머리말).
import './styles/theme-surfaces.css';
import './styles/aura.css';
// 보조 글자 대비 4.5:1(2026-10-17 · web 레인 W1) — --text-subtle 덮기 · 장식은 옛 값(그 파일 머리말).
import './styles/web-frame-contrast.css';
// 꺼진 단추 · 스위치 꼴 · 2열 대표 단추 테두리(2026-10-17 · web 레인 W2) — 그 파일 머리말.
import './styles/web-frame-buttons.css';
// 깨진 배치 · 입력칸 · 체크 칸 · 표 머리 한 꼴(2026-10-17 · web 레인 W4) — 두 파일 머리말.
import './styles/web-frame-layout.css';
import './styles/web-frame-fields.css';
// 2열 메뉴 접힌 묶음 · 메일 «쓰는 중»(2026-10-17 · web 레인 W5) — 그 파일 머리말.
import './styles/web-frame-tree.css';
// 쪽 머리 범위 칩(2026-10-17 · web 레인 W6) — 그 파일 머리말.
import './styles/web-frame-head.css';
// 영문 내부 값 = 이름 아래 작은 회색 글(2026-10-18 · web 레인 W9) — 그 파일 머리말.
import './styles/web-frame-codes.css';
// 테두리 대비 둘 — 근태 요약 알약 · 퀵바 메뉴(2026-10-18 · web 레인 W11a) — 그 파일 머리말.
import './styles/web-frame-status.css';
import { router } from './router';
import { setupGlobalErrorHandlers } from './lib/telemetry';
import { installChunkReloadGuard } from './lib/chunk-reload';
// 테마는 개인이 관리한다 (2026-09-02 사용자 결정) — 회사 기본 테마는 걷어냈다.
// 로그인 뒤 AuthGuard 가 개인 색을 입힌다. 로그인 화면은 앱 기본색으로 뜬다.

// Cycle 48 — React tree 외 async/Promise error 도 telemetry endpoint 로 보고.
// ErrorBoundary (componentDidCatch) 는 render error 만 잡으므로 window-level hook 으로 보완.
setupGlobalErrorHandlers();

// 2026-08-19 — 배포로 사라진 청크를 만난 오래된 탭은 스스로 한 번 새로 고친다.
// (증상: 며칠 열어 둔 탭에서 한글 첨부를 열면 `Failed to fetch dynamically imported module`)
installChunkReloadGuard();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
